export const tabelaPrecoFormStructure = [
  [
    {
      name: 'id',
      label: 'Id',
      component: 'FormField',
      type: 'number',
      colProps: { md: 2 },
      readOnly: true,
      disabled: true
    },
    {
      name: 'nomeTabelaPrecoDeposito',
      label: 'Nome',
      component: 'FormField',
      type: 'text',
      colProps: { md: 6 },
      maxLength: 255
    },
    {
      name: 'nomeResponsavel',
      label: 'Nome Responsavel',
      component: 'FormField',
      type: 'text',
      colProps: { md: 4 },
      maxLength: 255
    }
  ],
  [
    {
      name: 'valorUnPallet',
      label: 'Valor Pallet',
      component: 'CurrencyInput',
      placeholder: '0,00',
      colProps: { md: 3 }
    },
    {
      name: 'valorUnEtiqueta',
      label: 'Valor Etiqueta',
      component: 'CurrencyInput',
      placeholder: '0,00',
      colProps: { md: 3 }
    },
    {
      name: 'valorUnArmazenagemPallet',
      label: 'Valor Arm. Pallet',
      component: 'CurrencyInput',
      placeholder: '0,00',
      colProps: { md: 3 }
    },
    {
      name: 'freetime',
      label: 'Freetime',
      component: 'FormField',
      type: 'number',
      colProps: { md: 3 }
    }
  ],
  [
    {
      name: 'cobrarPaletizacaoRetrabalho',
      label: 'Cobrar paletização somente em retrabalho',
      component: 'CheckBox',
      type: 'checkbox',
      colProps: { md: 6 }
    },
    {
      name: 'cobrarEtiquetagemRetrabalho',
      label: 'Cobrar etiquetagem somente em retrabalho',
      component: 'CheckBox',
      type: 'checkbox',
      colProps: { md: 6 }
    }
  ],
  [
    {
      name: 'dataVigenciaInicio',
      label: 'Vigencia Inicio',
      component: 'DatePickers',
      type: 'date',
      colProps: { md: 6 }
    },
    {
      name: 'dataVigenciaFim',
      label: 'Vigencia Fim',
      component: 'DatePickers',
      type: 'date',
      colProps: { md: 6 }
    }
  ],
  [
    {
      name: 'observacoes',
      label: 'Observacoes',
      component: 'Textarea',
      type: 'textarea',
      colProps: { md: 12 },
      rows: 3
    }
  ]
];

export const tabelaPrecoFormSections = () => [
  { title: 'Identificacao - Quando o Id não estiver preenchido, é para inserir uma nova tabela de preço', rows: [0] },
  { title: 'Valores', rows: [1, 2] },
  { title: 'Vigencia', rows: [3] },
  { title: '', rows: [4] }
];

export const validateTabelaPrecoForm = (values) => {
  const errors = {};

  if (values.dataVigenciaInicio && values.dataVigenciaFim) {
    const inicio = new Date(values.dataVigenciaInicio);
    const fim = new Date(values.dataVigenciaFim);
    if (fim < inicio) {
      errors.dataVigenciaFim = 'Data final deve ser posterior a data inicial';
    }
  }

  return errors;
};
